export default {
  title: 'Einstellungen',
  fields: {
    name: {
      label: 'Name',
      placeholder: 'Restaurantname eingeben',
    },
    short_name: {
      label: 'Kurzer Name',
      placeholder: 'Kurznamen des Restaurants eingeben',
      tooltip:
        'Manchmal sind die Standardnamen von Restaurants sehr lang und können sekundäre Informationen enthalten, so dass in manchen Fällen (z. B. bei kürzeren Meldungen) eine kürzere Version des Namens erforderlich ist',
    },
    phone_number: {
      label: 'Rufnummer',
      placeholder: 'Rufnummer des Restaurants eingeben',
    },
    email: {
      label: 'Email',
      placeholder: 'Restaurant-E-Mail eingeben',
    },
    slug: {
      label: 'Slug',
      placeholder: 'Slug der Marke',
    },
    language: {
      label: 'Sprache',
      placeholder: 'Standard der Gruppe verwenden',
      tooltip:
        'Die Sprache, die Kunden im Onlineshop dieses Restaurants sehen, und die Voreinstellung für dessen Mitarbeiter. Leer lassen, um die Sprache der Marke zu übernehmen. Mitarbeiter können für ihre eigene Ansicht weiterhin eine eigene Sprache wählen.',
    },
    sms_name: {
      label: 'SMS Name',
      placeholder: 'SMS angezeiger Name',
    },
    timezone: {
      label: 'Zeitzone',
      placeholder: 'Nach Stadt oder Zeitzone suchen',
      tooltip:
        'Die Zeitzone, in der dieses Restaurant arbeitet. Sie bestimmt Bestellzeitstempel, Öffnungszeiten und Zeitfenster für Vorbestellungen. Sie wurde bei der Erstellung des Restaurants aus dessen Adresse übernommen — korrigieren Sie sie hier, falls sie nicht stimmt.',
    },
    time_format: {
      label: 'Zeitformat',
      placeholder: 'Standard des Landes verwenden',
      tooltip:
        'Wie Uhrzeiten Ihrem Team angezeigt werden — im Dashboard und im Bestellportal. Leer lassen, um der Konvention der Region des Restaurants zu folgen.',
      options: {
        '12h': '12-Stunden (5:30 pm)',
        '24h': '24-Stunden (17:30)',
      },
    },
    primary_color: {
      label: 'Primäre Farbe',
    },
    instagram_link: {
      label: 'Instagram link',
      placeholder: 'Restaurant Instagram Link eingeben',
    },
    website_link: {
      label: 'Website link',
      placeholder: 'Link zur Restaurant-Website eingeben',
    },
    impressum_link: {
      label: 'Impressum link',
      placeholder: 'Restaurant Impressum Link eingeben',
    },
    restaurant_type: {
      label: 'Restauranttyp & Servicemodell',
    },
    cuisine_types: {
      label: 'Essenskategorien & Küchenstile',
    },
  },
  test_restaurant: {
    title: 'Testrestaurant',
    description:
      'Machen Sie dieses Restaurant zu Ihrem Testrestaurant, um Druck, E-Mails, Bestellungen und Integrationen im Live-Betrieb zu testen. Es funktioniert weiter wie jedes andere Restaurant und wird nie abgerechnet. Sie können ein Testrestaurant haben.',
    description_test:
      'Dies ist Ihr Testrestaurant. Es funktioniert wie jedes andere Restaurant und wird nie abgerechnet. Kunden-E-Mails und -SMS zu seinen Bestellungen beginnen mit [TEST].',
    mark: 'Als Testrestaurant markieren',
    remove: 'Test-Markierung entfernen',
    slot_taken:
      'Sie haben bereits ein Testrestaurant ({{name}}). Entfernen Sie zuerst die Test-Markierung von Ihrem bisherigen.',
  },
  buttons: {
    save: 'Speichern',
  },
  toasts: {
    info_updated: 'Erfolgreich Einstellungen aktualisiert',
  },
};
